export default __webpack_public_path__ + "locales/ru/Errors.json?hash=2d32e2eef6d302ed95e1bde4f48cbbb6";